import React, { Component } from 'react';
import { Responsive, WidthProvider } from 'react-grid-layout';
import { Commun } from '../../utils/axios'
import styles from './task.module.scss';
import 'react-grid-layout/css/styles.css';
import 'react-resizable/css/styles.css';
import intl from 'react-intl-universal';
import dayjs from 'dayjs';
import common from '../../common/common';


const ResponsiveGridLayout = WidthProvider(Responsive);



class Task extends Component {
  constructor(props) {
    super(props);
    this.state = {  
      dataList: [],
      showPic: false,
      theme: ""
    }
  }
  componentDidMount() {
    document.title = '星星任务';
    const searchParams = common.getSearchParam();
    this.setState({theme: searchParams?.theme || "roombox"})
    Commun.get('/api/client/star/task/list').then(res => {
      console.log('star res', res);
      if(!res){
        this.nothing();
        return;
      };
      let originAttendance = res.starTask?.attendance;
      if(Object.keys(res).length === 0){
        console.log("response is empty object");
        this.nothing();
        return;
      };
      let task = res.starTask;
      let nextClass = res.nextClass;
      let latestClassInPast = res.latestClassInPast;
      let attendanceArr = [];
      attendanceArr = originAttendance?.isShowComponent === 1 
      ?
      (originAttendance?.classData || []).map(item => ({
        ...item,
        name: 'attendance',
        hasClass: originAttendance?.hasClass,
        ruleText: originAttendance?.ruleText
      }))
      :
      [];
      let temp = Object.keys(task).filter((key)=> key !== 'attendance').map((item,index) => {
        if(item === 'playback') {
          return ({
            ...task[item],
            name: item, 
            latestClassInPast
          })
        }
        return ({
          ...task[item],
          name: item,
          nextClass
        })
      }).filter(element => element.isShowComponent === 1);
      let data = [...temp, ...attendanceArr];
      console.log('format data ~~~ empty', data);
      this.setState({
        dataList: data,
        showPic: data.length === 0
      });
    });
  }
  nothing = () => {
    this.setState({
      showPic: true
    });
  }
  handleDesc = (item) => {
    let text = '';
    if(item.hasClass !== 1) {
      switch(item.name) {
        case 'attendance':
          // text = '今天没有课程，去预习下一节课内容吧~';
          break;
        case 'playback':
          text = intl.get("GO_AND_TAKE_ONE");
          break;
        default:
          text = intl.get("GET_READY_FOR_ONE");
      }
    }else{
      switch(item.name) {
        case 'sign':
          text = intl.get("SIGNED_TODAY", {num: item.num});
          break;
        case 'interact':
          text = intl.get("TIME_TODAY", {num: item.num});
          break;
        case 'live': 
          text = intl.get("PERCENT_TODAY", {num: item.num});
          break;
        case 'rank':
          text = intl.get("RANK_NUMBER", {num: item.num});
          break;
        case 'playback':
          text = item.isWatch === 1 ? intl.get("PLAYBACK_COMPLETE") : intl.get("PLAYBACK_NOT_COMPLETE");
          break;
        case 'attendance':
          text = `${item.className ?? ""} ${intl.get("ATTENDANCE_NUMBER", {num: item.num})}`;
          break;
        default: 
      }
    }
    return text;
  }
  formatTime = (objTime) => {
    let start = objTime?.startTime;
    let end = objTime?.endTime;
    if(!start || !end) return "";
    if(dayjs.unix(start).isSame(dayjs.unix(end), 'day')){
      return `${dayjs.unix(start).format('YYYY/MM/DD HH:mm')}-${dayjs.unix(end).format('HH:mm')}`
    } else {
      return `${dayjs.unix(start).format('YYYY/MM/DD HH:mm')}-${dayjs.unix(end).format('YYYY/MM/DD HH:mm')}`
    }
  }
  componentWillUnmount(){
    document.title = '我的星星';
  }
  render() { 
    // layout is an array of objects, see the demo for more complete usage
    const { dataList, showPic, theme } = this.state;
    const big = dataList.map((item, index) => ({
      i: index + 1 + "",
      x: index % 2 ? 6 : 0,
      y: 0,
      w: 6,
      h: 1
    }));
    const small = dataList.map((item, index) => ({
      i: index + 1 + '',
      x: 0,
      y: 0,
      w: 6,
      h: 1
    }))
    const layouts = {
      md: big,
      sm: small,
    }

    return (
      <div className={`${styles.taskPage} light-scroll-bar`}>
        {
          showPic && (
            <div className={styles.nothingBox}>
              <img width={160} src={require("../../assets/img/starList/p-list-course.png")} alt=""/>
              <div className={styles.nothingText}>
                {
                  intl.get('LIST_EMPTY')
                }
              </div>
            </div>
          )
        }
        {
          dataList.length > 0 ? <ResponsiveGridLayout className={styles.layout}
            isDraggable={false}
            isResizable={false}
            layouts={layouts}
            breakpoints={{ md: 996, sm: 768}}
            cols={{ md: 12, sm: 6}}
            rowHeight={theme?.toLowerCase() === "roomboxlight" || theme?.toLowerCase() === "meikelight" ? 190 : 170}
          > 
            {
              this.state.dataList.map((item, index) => (
                <div key={"" + (index + 1)} className={styles.item}>
                  <div className={styles.title}>
                    {
                      intl.get(`${item.name?.toUpperCase()}`)
                    }
                  </div>
                  <div className={styles.desc} title={item.desc}>
                    {
                      item.ruleText
                    }
                  </div>
                  <div className={styles.content}>
                    <div className={styles.left}>
                      <span className={styles.itemIcon}>
                        <img src={require(`../../assets/img/starTask/${item.type ?? item.name}.png`)} alt="" />
                      </span>
                      <span className={styles.iconDesc}>
                        {
                          this.handleDesc(item)
                        }
                      </span>
                    </div>
                    <div className={styles.right}>
                      <span className={styles.starNum}>
                        {
                          (item.star ?? 0) > 999 ? `+${(item.star / 1000).toFixed(1)}k` : `+${item.star ?? 0}`
                        }
                      </span>
                      <img className={styles.starIcon} src={require("../../assets/img/starTask/starIcon.png")} alt="" />
                    </div>
                  </div>
                  <div className={styles.info}>
                    {
                      (item?.latestClassInPast?.classroomName || item?.nextClass?.classroomName)
                      ? 
                        // `${item.name === 'playback' ? `上一节课 ：${this.formatTime(item?.latestClassInPast)} ${item?.latestClassInPast?.classroomName}` : `下一节课 ：${this.formatTime(item?.nextClass)} ${item?.nextClass?.classroomName}`}`
                      (
                          item.name === 'playback' ? `${intl.get("PREV_LESSON")} ：${this.formatTime(item?.latestClassInPast)} ${item?.latestClassInPast?.classroomName}` : `${intl.get("NEXT_LESSON")} ：${this.formatTime(item?.nextClass)} ${item?.nextClass?.classroomName}`
                      )
                      :
                      intl.get("STAR_TASK_TIP")
                    }
                  </div>
                </div>
              ))
            }
          </ResponsiveGridLayout>
          : 
          ""
        }
      </div>
    )
  }
}
 
export default Task;